import { FormControl, FormGroup, Validators } from '@angular/forms';

import { AddressForm } from './address-form';

export class CompanyOfficeForm extends FormGroup<{
  id: FormControl<number | undefined>;
  CompanyId: FormControl<number | undefined>;
  officeName: FormControl<string | undefined>;
  Address?: AddressForm;
  StreetAddress: AddressForm;
}> {
  constructor() {
    super({
      id: new FormControl<number | undefined>(undefined, { nonNullable: true }),
      CompanyId: new FormControl<number | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),
      officeName: new FormControl<string | undefined>(undefined, {
        nonNullable: true,
        validators: [Validators.required]
      }),

      StreetAddress: new AddressForm()
    });
  }
}
